import { render, staticRenderFns } from "./ConfirmShareModal.vue?vue&type=template&id=5070d00f&scoped=true"
import script from "./ConfirmShareModal.vue?vue&type=script&lang=js"
export * from "./ConfirmShareModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmShareModal.vue?vue&type=style&index=0&id=5070d00f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5070d00f",
  null
  
)

export default component.exports